import React from 'react'

export default function Services() {
  return (
    <div style={{height:"63vh"}}>
    <h1  style={{
          textAlign: "center",
          marginTop: "3rem",
          fontSize: "2rem",
          fontWeight: "600",
          margin: "3rem 0",
        }}>Services Section</h1>
  </div>
  )
}
